import React, { FC } from "react";
import MuiAppBar, { AppBarProps } from "@material-ui/core/AppBar";

const AppBar: FC<AppBarProps> = (props) => {
  return (
    <MuiAppBar {...props} />
  );
};

export default AppBar;
